export const deviceDisableReason = {
  DISABLED_BY_PROFILE: "DISABLED_BY_PROFILE",
  NO_PERMISSION: "NO_PERMISSION",
  NO_DEVICE: "NO_DEVICE",
  SUSPENDED: "SUSPENDED",
  SOFT_MUTED: "VIDYO_ROOMMODERATIONTYPE_SoftMute",
  HARD_MUTED: "VIDYO_ROOMMODERATIONTYPE_HardMute",
};

export const deviceTooltipTimeout = 3000;

export const privacyPolicyLink = "https://www.vidyo.com/privacy-policy";
export const termsAndConditionsLink =
  "https://www.vidyo.com/cloudservices-user-terms-and-conditions";
export const patentNotices = "https://www.vidyo.com/company/patent-notices";
export const vidyoOSSAttributions =
  "http://www.vidyo.com/wp-content/uploads/Vidyo-OSS-Attributions.pdf";
export const eulaAgreement = "http://www.vidyo.com/eula";

export const tcData = {
  LINK_URL: "https://links.vidyocloud.com",
  LINK_JSON_NAME: "links.json",
  TENANT_JSON_NAME: "tenantsdirectory.json",
  TERMS_JSON_NAME: "terms",
  PRIVACY_JSON_NAME: "privacy",
  LOCAL_VERSION: "tcConsentVersion",
  SERVER_TIMEOUT: 10 * 1000,
};

export const tabletsGridParticipantLimit = 3;
export const participantLimit = 8;

export const keyboardShortcutWin = {
  TOOGLE_MIC: "ctrl+shift+a",
  TOOGLE_SPEAKER: "ctrl+shift+k",
  TOOGLE_CAMERA: "ctrl+shift+d",
  PUSH_TO_TALK: "ctrl+space",
  PUSH_TO_TALK_TEXT: "ctrl+space",
  TOOGLE_CHAT_PANEL: "ctrl+shift+h",
  TOOGLE_SIDE_PANEL: "ctrl+shift+p",
  TOOGLE_CC: "ctrl+shift+c",
  END_CALL: "ctrl+shift+e",
  TOOGLE_MODERATION_PANEL: "ctrl+shift+r",
  TOOGLE_INVITE_PANEL: "ctrl+shift+i",
};

export const keyboardShortcutMac = {
  TOOGLE_MIC: "⌘+shift+a",
  TOOGLE_SPEAKER: "⌘+shift+k",
  TOOGLE_CAMERA: "⌘+shift+d",
  PUSH_TO_TALK: "alt+space",
  PUSH_TO_TALK_TEXT: "⌥+space",
  TOOGLE_CHAT_PANEL: "⌘+shift+h",
  TOOGLE_SIDE_PANEL: "⌘+shift+p",
  TOOGLE_CC: "⌘+shift+c",
  END_CALL: "⌘+shift+e",
  TOOGLE_MODERATION_PANEL: "⌘+shift+r",
  TOOGLE_INVITE_PANEL: "⌘+shift+i",
};

export const TAB_INDEX_BEAUTY_SCREEN =
  '[data-test-id="VIDYOCONNECT_LOGO"], #welcomeTextOnGuestPage, input, .device-toggle button, #termsAndConditionText a, .hardware-check-launch, #gustJoinButton, .guest-settings-icon button';
export const TAB_INDEX_SETTING =
  '#settings-content .tab, #settings-content button, input[type="checkbox"]';
export const TAB_INDEX_IN_CALL =
  '[data-test-id="ROSTER_BUTTON"], .in-call button,.in-call .settings-toggle';
